import { getSelectedMapDate } from "./mapsPRCalendar.js";

// [A] Global Variables  ============================================
let mapsPRData = {
  igp_sphi: null, // Save JSON from igp_sphi.dat.xz
};

const sphiMapBtn = document.getElementById("sphiMapPRBtn");
sphiMapBtn.classList.add("boxContainer__titleH3--disabled");
document.getElementById("hourButtonsPR").classList.remove("hourButtonsContainer--visible");

// [B] Handle Fetch Flags =========================================
const isFetching = {
  igp_sphi: false,
};

function handlerSpinner(show) {
  const spinner = document.getElementById("loadingMessagePRMaps");
  const map = document.getElementById("sphiMapPRContainer");

  if (show) {
    // hide mapa and save the status "visible"
    map.dataset.wasVisible = map.style.display === "block";
    map.style.display = "none";
    spinner.style.display = "flex";
  } else {
    spinner.style.display = "none";
    // Show the map only if it was visible before
    if (map.dataset.wasVisible === "true") {
      map.style.display = "block";
    }
    delete map.dataset.wasVisible;
  }
}

// [C] Obtain historical data from igp_sphi.dat.xz ====================
async function fetchRawIgpSphiData(year, doy) {

  if (isFetching.igp_sphi) {
    //console.warn("SPHI application in process. Avoiding overlapping.");
    return null;
  }

  isFetching.igp_sphi = true; // Activate the flag
  try {
    // const url = `http://127.0.0.1:5000/api/mapsPR/read-igp-sphi/${year}/${doy}`;
    const url = `https://rtwmis.gage.upc.edu/api/mapsPR/read-igp-sphi/${year}/${doy}`;
    const response = await fetch(url);
    toggleConnectionAlert(false);

    if (!response.ok) {
      throw new Error(`HTTP error for SPHI: ${response.status}`);
    }

    return await response.json();
  } finally {
    isFetching.igp_sphi = false; // Desactivate the flag
  }
}

// [D] Filter data for SPHI =====================================
function filterSphiData(rawData) {
  return rawData.map((group) => ({
    TIME: group.TIME,
    data: group.data
      .map((cell) => ({
        Longitude: cell.Longitude ?? null,
        Latitude: cell.Latitude ?? null,
        mean_sphi: cell.mean_sphi ?? null,
      }))
      .filter((cell) => cell.Longitude !== null && cell.Latitude !== null),
  }));
}

// [E] Group blocks by hour and 10-minute block ================================
function groupByHourAndBlock(filteredData) {
  // Create result object: keys 0...23, each one an array of 6 positions (null by default)
  const byHourBlock = {};
  for (let h = 0; h < 24; h++) byHourBlock[h] = Array(6).fill(null);

  filteredData.forEach((block) => {
    const hour = Math.floor(block.TIME / 3600);
    const blockIdx = Math.floor((block.TIME % 3600) / 600);
    if (hour >= 0 && hour < 24 && blockIdx >= 0 && blockIdx < 6) {
      byHourBlock[hour][blockIdx] = block;
    }
  });
  return byHourBlock;
}

// [F] Main function for SPHI ============================================
export async function fetchIgpSphiData(year, doy) {
  try {
    const rawData = await fetchRawIgpSphiData(year, doy);
    const hasUsefulData = Array.isArray(rawData) && rawData.some(group => Array.isArray(group.data) && group.data.length > 0);
    
    if (!rawData || !hasUsefulData) {

      toggleConnectionAlert(true);
      // If there is no data, clear the structure and update buttons
      mapsPRData.igp_sphi_byHourBlock = {};
      hourBtnAvailability();
      hourDropdownAvailability();
      return null;
    }

    const filteredData = filterSphiData(rawData);
    mapsPRData.igp_sphi = filteredData;
    sphiMapBtn.classList.remove("boxContainer__titleH3--disabled");

    // Group and save in new variable
    mapsPRData.igp_sphi_byHourBlock = groupByHourAndBlock(filteredData);
    hourBtnAvailability();
    hourDropdownAvailability();
    return filteredData;

  } catch (error) {
    console.error("Error obtaining or processing SPHI data:", error.message);
    // if there is an error, clear the structure and update buttons
    mapsPRData.igp_sphi_byHourBlock = {};
    hourBtnAvailability();
    hourDropdownAvailability();
    document.getElementById("hourButtonsPR").classList.remove("hourButtonsContainer--visible");
    handlerSpinner(false);
  }
}

// [G] Update hour button availability ====================================================
function hourBtnAvailability() {
  const byHourBlock = mapsPRData.igp_sphi_byHourBlock;
  document.querySelectorAll('#hourButtonsPR button.tertiaryBtn').forEach((btn) => {
    const hour = parseInt(btn.getAttribute('data-hour'), 10);
    const hasData = (byHourBlock[hour] || []).some(b => b && b.data && b.data.length > 0);
    if (!hasData) {
      btn.classList.add('tertiaryBtn--disabled');
      btn.disabled = true; // Opcional, útil para accesibilidad
    } else {
      btn.classList.remove('tertiaryBtn--disabled');
      btn.disabled = false;
    }
  });
}

// [H] Update hour button availability ====================================================
function hourDropdownAvailability() {
  const byHourBlock = mapsPRData.igp_sphi_byHourBlock;
  const hourSelect = document.getElementById("hourSelectPR");
  // Clear the hour select dropdown
  hourSelect.innerHTML = "";
  for (let h = 0; h < 24; h++) {
    const option = document.createElement("option");
    option.value = h;
    //option.textContent = h.toString().padStart(2, "0") + ":00";
    option.textContent = `${h}h`;
    // Check if there is data in that hour
    const hasData = (byHourBlock[h] || []).some(b => b && b.data && b.data.length > 0);
    if (!hasData) {
      option.disabled = true;
      option.classList.add("selectOption--disabled");
    }
    hourSelect.appendChild(option);
  }
}

// [I] Clear hour and minute block selections =============================================
function clearHourAndMinuteSelections() {
  document.querySelectorAll('#hourButtonsPR .tertiaryBtn.active-button').forEach(btn => {
    btn.classList.remove('active-button');
  });
  document.getElementById("hourSelectPR").selectedIndex = 0;
  document.getElementById("blockSelectPR").selectedIndex = 0;
}

// [J] On date change ===========================================
document
  .getElementById("dateInputMaps")
  .addEventListener("change", async function () {
    const { year, doy } = getSelectedMapDate(this.value);
    console.log(
      "Selected Date:",
      this.value,
      "Year:",
      year,
      "DDay of Year (DoY):",
      doy
    );

    window.dispatchEvent(new Event("cleanMapPR"));
    clearHourAndMinuteSelections();

    handlerSpinner(true);
    await fetchIgpSphiData(year, doy);
    handlerSpinner(false);
  });

// [K] Update hour button availability ====================================================
document.getElementById('blockPrevBtn').addEventListener('mousedown', function(e) {
  e.preventDefault(); // Previene que quede enfocado
  this.blur();
});

// [L] Update hour button availability ====================================================
document.getElementById('blockNextBtn').addEventListener('mousedown', function(e) {
  e.preventDefault();
  this.blur();
});

// [Z] Getter to get the filtered block by hour and 10-minute block ============
export function getSphiBlockByHourAndMinute(hour, blockIdx) {
  if (!mapsPRData.igp_sphi_byHourBlock) return null;
  return mapsPRData.igp_sphi_byHourBlock[hour]?.[blockIdx] ?? null;
}

// [AUTO-PLAY] ================================================================

// [A] Player state variables
let isAutoPlaying = false;
let autoPlayIntervalId = null;
let autoPlayIndex = 0;
let activeHourButtons = [];

// [B] Start auto-play for available hour buttons
function startAutoPlay() {
  const playButton = document.getElementById("autoPlayHoursBtn");

  // [B.1] Get active hour buttons (those not disabled)
  activeHourButtons = Array.from(document.querySelectorAll("#hourButtonsPR .tertiaryBtn"))
    .filter(btn => !btn.classList.contains("tertiaryBtn--disabled"))
    .sort((a, b) => parseInt(a.dataset.hour, 10) - parseInt(b.dataset.hour, 10)); // Ascending order

  if (activeHourButtons.length === 0) {
    //console.warn("No active hour buttons for Sphi.");
    return;
  }

  // [B.2] Prepare state and UI
  isAutoPlaying = true;
  autoPlayIndex = 0;
  playButton.textContent = "⏸️";
  playButton.classList.add("playing");

  // [B.3] Simulate one click every second (adjustable)
  autoPlayIntervalId = setInterval(() => {
    if (autoPlayIndex >= activeHourButtons.length) {
      stopAutoPlay(); // End of playback
      return;
    }

    activeHourButtons[autoPlayIndex].click();
    autoPlayIndex++;
  }, 1300);
}

// [C] Stop auto-play
function stopAutoPlay() {
  const playButton = document.getElementById("autoPlayHoursBtn");
  clearInterval(autoPlayIntervalId);
  autoPlayIntervalId = null;
  isAutoPlaying = false;
  autoPlayIndex = 0;
  playButton.textContent = "▶️";
  playButton.classList.remove("playing");
}

// [D] Toggle auto-play on/off
function toggleAutoPlay() {
  if (isAutoPlaying) {
    stopAutoPlay();
  } else {
    startAutoPlay();
  }
}

// [X] Show or hide connection error message =======================================
function toggleConnectionAlert(show) {
  const alertBox = document.getElementById("alertConnectionLostPastMapsSPHI");
  if (!alertBox) return;
  alertBox.style.display = show ? "block" : "none";
}

// [E] Attach listener to play/pause button
document.getElementById("autoPlayHoursBtn").addEventListener("click", toggleAutoPlay);